/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { WebhookAuthConfigV1Service } from './services/webhook-auth-config-v-1.service';
import { VerificationSupportV1Service } from './services/verification-support-v-1.service';
import { FormApprovalConfigV1Service } from './services/form-approval-config-v-1.service';
import { ApprovalV1Service } from './services/approval-v-1.service';
import { DaprControllerService } from './services/dapr-controller.service';
import { VerificationSupportService } from './services/verification-support.service';
import { VerificationDecisionService } from './services/verification-decision.service';
import { AppInsightsService } from './services/app-insights.service';
import { WebhookDeliveryLogV1Service } from './services/webhook-delivery-log-v-1.service';
import { VerificationDecisionV1Service } from './services/verification-decision-v-1.service';
import { VerificationResultsV1Service } from './services/verification-results-v-1.service';
import { TinVerificationV1Service } from './services/tin-verification-v-1.service';
import { SupplierV1Service } from './services/supplier-v-1.service';
import { SupplierRequestV1Service } from './services/supplier-request-v-1.service';
import { ReportingV1Service } from './services/reporting-v-1.service';
import { NotificationsV1Service } from './services/notifications-v-1.service';
import { SystemAnnouncementsV1Service } from './services/system-announcements-v-1.service';
import { MigrationService } from './services/migration.service';
import { MfaV1Service } from './services/mfa-v-1.service';
import { V1ValueListIntegrationService } from './services/v-1-value-list-integration.service';
import { IntegrationsV1Service } from './services/integrations-v-1.service';
import { V1SupplierIntegrationService } from './services/v-1-supplier-integration.service';
import { V1RequestIntegrationService } from './services/v-1-request-integration.service';
import { ScimUsersV1Service } from './services/scim-users-v-1.service';
import { IbanVerificationV1Service } from './services/iban-verification-v-1.service';
import { HomepageSummaryV1Service } from './services/homepage-summary-v-1.service';
import { GstVerificationV1Service } from './services/gst-verification-v-1.service';
import { GlobalTinVerificationV1Service } from './services/global-tin-verification-v-1.service';
import { GlobalKybVerificationV1Service } from './services/global-kyb-verification-v-1.service';
import { FormService } from './services/form.service';
import { FilesV1Service } from './services/files-v-1.service';
import { EuVatVerificationV1Service } from './services/eu-vat-verification-v-1.service';
import { EmailDomainVerificationV1Service } from './services/email-domain-verification-v-1.service';
import { BankVerificationV1Service } from './services/bank-verification-v-1.service';
import { AmlScreeningVerificationV1Service } from './services/aml-screening-verification-v-1.service';
import { AdverseMediaVerificationV1Service } from './services/adverse-media-verification-v-1.service';
import { UserService } from './services/user.service';
import { TinVerificationService } from './services/tin-verification.service';
import { OrganizationsService } from './services/organizations.service';
import { TermsService } from './services/terms.service';
import { IbanVerificationService } from './services/iban-verification.service';
import { ForgotPasswordService } from './services/forgot-password.service';
import { ConfigService } from './services/config.service';
import { BankVerificationService } from './services/bank-verification.service';
import { AuditingService } from './services/auditing.service';
import { WebhookFormSubscriptionV1Service } from './services/webhook-form-subscription-v-1.service';
import { ExternalValueListService } from './services/external-value-list.service';
import { ScimSchemasV1Service } from './services/scim-schemas-v-1.service';
import { V1FormIntegrationService } from './services/v-1-form-integration.service';
import { DataPatchService } from './services/data-patch.service';
import { CustomerDocsV1Service } from './services/customer-docs-v-1.service';
import { GreetingService } from './services/greeting.service';
import { AccessControlPermissionsService } from './services/access-control-permissions.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    WebhookAuthConfigV1Service,
    VerificationSupportV1Service,
    FormApprovalConfigV1Service,
    ApprovalV1Service,
    DaprControllerService,
    VerificationSupportService,
    VerificationDecisionService,
    AppInsightsService,
    WebhookDeliveryLogV1Service,
    VerificationDecisionV1Service,
    VerificationResultsV1Service,
    TinVerificationV1Service,
    SupplierV1Service,
    SupplierRequestV1Service,
    ReportingV1Service,
    NotificationsV1Service,
    SystemAnnouncementsV1Service,
    MigrationService,
    MfaV1Service,
    V1ValueListIntegrationService,
    IntegrationsV1Service,
    V1SupplierIntegrationService,
    V1RequestIntegrationService,
    ScimUsersV1Service,
    IbanVerificationV1Service,
    HomepageSummaryV1Service,
    GstVerificationV1Service,
    GlobalTinVerificationV1Service,
    GlobalKybVerificationV1Service,
    FormService,
    FilesV1Service,
    EuVatVerificationV1Service,
    EmailDomainVerificationV1Service,
    BankVerificationV1Service,
    AmlScreeningVerificationV1Service,
    AdverseMediaVerificationV1Service,
    UserService,
    TinVerificationService,
    OrganizationsService,
    TermsService,
    IbanVerificationService,
    ForgotPasswordService,
    ConfigService,
    BankVerificationService,
    AuditingService,
    WebhookFormSubscriptionV1Service,
    ExternalValueListService,
    ScimSchemasV1Service,
    V1FormIntegrationService,
    DataPatchService,
    CustomerDocsV1Service,
    GreetingService,
    AccessControlPermissionsService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
